import React from 'react';
import PropTypes from 'prop-types';
// components
import { Button, CircularProgress } from '@mui/material';

// --------------------------------------------------

PrimaryButton.propTypes = {
  variant: PropTypes.oneOf(['contained', 'outlined']).isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default function PrimaryButton({ variant, onClick, loading, disabled, children }) {
  return (
    <Button
      fullWidth
      variant={variant}
      sx={{ 
        padding: '12px 60px', 
        fontSize: '16px', 
        minWidth: '120px', 
        borderRadius: 2 
      }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <CircularProgress size={20} /> : children}
    </Button>
  );
}
